import React from 'react';
import BackgroundImageSettings from '../../../Components/BackgroundImageSettings';
import AssetStatusSettings from '../../../Components/AssetStatusSettings';
import BoxWidgetSettings from '../../../Components/BoxWidgetSettings';
import EnvironmentalStatusSettings from '../../../Components/EnvironmentalStatusSettings';
import StatusArrowSettings from '../../../Components/StatusArrowSettings';
import TextTitleSettings from '../../../Components/TextTitleSettings';
import TimeRangeSettings from '../../../Components/TimeRangeSettings';
import { ENVIRONMENTAL_STATUS_WIDGET_TYPE } from '../../../widgets/environmentalStatusConfig';
import { ASSET_STATUS_WIDGET_TYPE, STATUS_ARROW_WIDGET_TYPE } from '../../../widgets/assetStatusUtils';

const WidgetSpecialSettings = ({
	edit,
	setEdit,
	alignments,
	devices,
	validDatastreams,
	deviceSelectOptions,
}) => {
	if (edit.type === 'background-image') {
		return (
			<BackgroundImageSettings
				initialFile={edit?.props?.file || ''}
				initialUrl={edit?.props?.imageUrl || ''}
				initialLightFile={edit?.props?.lightFile || ''}
				initialLightUrl={edit?.props?.lightImageUrl || ''}
				initialDarkFile={edit?.props?.darkFile || ''}
				initialDarkUrl={edit?.props?.darkImageUrl || ''}
				onFileChanged={({ lightFile, darkFile, lightDeleted, darkDeleted }) => {
					setEdit((prev) => ({
						...prev,
						props: {
							...prev.props,
							lightFile,
							darkFile,
							lightImageUrl: lightDeleted ? null : prev.props?.lightImageUrl,
							darkImageUrl: darkDeleted ? null : prev.props?.darkImageUrl,
							useThemeImages: true,
							file: null,
							imageUrl: prev.props?.imageUrl,
						},
					}));
				}}
			/>
		);
	}

	if (edit.type === 'box-widget') {
		return <BoxWidgetSettings edit={edit} setEdit={setEdit} />;
	}

	if (edit.type === 'text-title') {
		return (
			<TextTitleSettings
				edit={edit}
				setEdit={setEdit}
				alignments={alignments}
				devices={devices}
				validDatastreams={validDatastreams}
				deviceOptions={deviceSelectOptions}
			/>
		);
	}

	if (edit.type === 'time-range') {
		return (
			<TimeRangeSettings
				edit={edit}
				setEdit={setEdit}
				devices={devices}
				validDatastreams={validDatastreams}
				deviceOptions={deviceSelectOptions}
			/>
		);
	}

	if (edit.type === ENVIRONMENTAL_STATUS_WIDGET_TYPE) {
		return (
			<EnvironmentalStatusSettings
				edit={edit}
				setEdit={setEdit}
				devices={devices}
				validDatastreams={validDatastreams}
				deviceOptions={deviceSelectOptions}
			/>
		);
	}

	if (edit.type === ASSET_STATUS_WIDGET_TYPE) {
		return (
			<AssetStatusSettings
				edit={edit}
				setEdit={setEdit}
				devices={devices}
				validDatastreams={validDatastreams}
				deviceOptions={deviceSelectOptions}
			/>
		);
	}

	if (edit.type === STATUS_ARROW_WIDGET_TYPE) {
		return (
			<StatusArrowSettings
				edit={edit}
				setEdit={setEdit}
				devices={devices}
				validDatastreams={validDatastreams}
				deviceOptions={deviceSelectOptions}
			/>
		);
	}

	return null;
};

export default WidgetSpecialSettings;
